<div class="page-wrap">
  <section class="contacts-grid">
    <article class="glass-panel page-panel">
      <div class="panel-top">
        <div>
          <p class="eyebrow">Contacts</p>
          <h1 class="hero-title">Manage your audience before launching templates and bulk campaigns.</h1>
        </div>
        <div class="panel-actions">
          <input
            #fileInput
            type="file"
            accept=".xlsx,.xls,.csv"
            class="hidden-file-input"
            (change)="onImportFileSelected($event)"
          />
          <ion-button
            fill="outline"
            color="secondary"
            (click)="openImportPicker(fileInput)"
            [disabled]="isImporting"
          >
            {{ isImporting ? 'Importing...' : 'Import Excel' }}
          </ion-button>
          <ion-button fill="outline" (click)="startCreate()">New contact</ion-button>
        </div>
      </div>

      <ion-searchbar
        placeholder="Search by name, phone, status, or tag"
        (ionInput)="onSearch($event)"
      ></ion-searchbar>

      <p class="supporting-copy" *ngIf="errorMessage">{{ errorMessage }}</p>
      <p class="import-copy" *ngIf="importMessage">{{ importMessage }}</p>
      <div class="import-help">
        <p class="subtle-copy">
          Supported columns: <strong>name</strong>, <strong>phone_number</strong> or
          <strong>phone</strong>, optional <strong>tags</strong> and <strong>status</strong>.
        </p>
      </div>
      <ion-list lines="none" class="import-errors" *ngIf="importErrors.length > 0">
        <ion-item *ngFor="let entry of importErrors">
          <ion-label>
            <h3>Row {{ entry.row }}</h3>
            <p>{{ entry.message }}</p>
          </ion-label>
        </ion-item>
      </ion-list>

      <ion-list lines="full" *ngIf="filteredContacts.length > 0">
        <ion-item *ngFor="let contact of filteredContacts; trackBy: trackByContactId">
          <ion-label>
            <h3>{{ contact.name }}</h3>
            <p>{{ contact.phone_number }} · {{ contact.status }}</p>
            <p *ngIf="contact.tags && contact.tags.length > 0">Tags: {{ contact.tags.join(', ') }}</p>
          </ion-label>

          <ion-buttons slot="end">
            <ion-button fill="clear" color="medium" (click)="editContact(contact)">Edit</ion-button>
            <ion-button fill="clear" color="danger" (click)="removeContact(contact)">Delete</ion-button>
          </ion-buttons>
        </ion-item>
      </ion-list>

      <div class="empty-state" *ngIf="!isLoading && filteredContacts.length === 0">
        <p class="section-title">No contacts found</p>
        <p class="subtle-copy">
          Add your first contact or adjust the search to see matching audience records.
        </p>
      </div>
    </article>

    <aside class="glass-panel editor-panel">
      <div class="editor-heading">
        <div>
          <p class="eyebrow">{{ isEditing ? 'Edit Contact' : 'Create Contact' }}</p>
          <h2 class="section-title">
            {{ isEditing ? 'Update audience details' : 'Add a recipient for campaigns' }}
          </h2>
        </div>
        <ion-button fill="clear" color="medium" *ngIf="isEditing" (click)="cancelEditing()">
          Cancel
        </ion-button>
      </div>

      <div [formGroup]="form" class="contact-editor">
        <ion-item>
          <ion-label position="stacked">Name</ion-label>
          <ion-input formControlName="name" placeholder="Aanya Retail"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Phone number</ion-label>
          <ion-input formControlName="phone_number" placeholder="+919876543210"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Tags</ion-label>
          <ion-input formControlName="tags" placeholder="vip, retail, wholesale"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Status</ion-label>
          <ion-select formControlName="status" interface="popover">
            <ion-select-option value="active">Active</ion-select-option>
            <ion-select-option value="inactive">Inactive</ion-select-option>
            <ion-select-option value="blocked">Blocked</ion-select-option>
          </ion-select>
        </ion-item>

        <div class="editor-actions">
          <ion-button expand="block" (click)="saveContact()" [disabled]="isSaving">
            {{ isSaving ? 'Saving...' : isEditing ? 'Update contact' : 'Create contact' }}
          </ion-button>
        </div>
      </div>
    </aside>
  </section>
</div>
